import React, { FC, useEffect } from 'react';
import { sendRestrictedModalAnalytics } from './restrictedModalAnalytics';
import styles from './restricted_modal_layout.module.scss';
import { MaterialIcon } from '../../../material-icon/MaterialIcon';

type Props = {
  closeModal: () => void;
  source: string;
};

export const RestrictedModalLayout: FC<Props> = ({
  source,
  closeModal,
  children,
}) => {
  useEffect(() => {
    sendRestrictedModalAnalytics(source);
  }, [source]);

  return (
    <>
      <div className={styles.header}>
        <button type="button" onClick={closeModal} className={styles.close}>
          <MaterialIcon name="close" />
        </button>
      </div>
      <div className={styles.content}>{children}</div>
    </>
  );
};
